/**
 * Grupează o listă de unități organizatorice după parent_id, pentru randare
 * arborescentă (vezi OrgStructure.jsx). O unitate e rădăcină VIZUALĂ dacă
 * n-are parent_id, SAU dacă parent_id-ul ei nu se regăsește printre unitățile
 * primite — nu modifică parent_id-ul real, doar decide sub ce cheie ("root"
 * sau id-ul părintelui) e bucketată unitatea pentru randare.
 *
 * De ce contează: backend-ul poate întoarce doar un subarbore (utilizator cu
 * acces scoped pe structură — vezi planco/scope.py:manager_scope_org_units),
 * caz în care vârful subarborelui are un parent_id real care nu mai apare în
 * lista primită. Fără această verificare, acea unitate ar rămâne bucketată
 * sub id-ul părintelui absent, pe care nimeni nu-l vizitează pornind de la
 * "root" — arborele s-ar randa gol. Pentru Admin/HR (listă completă), orice
 * parent_id existent e mereu prezent în listă, deci comportamentul rămâne
 * identic cu cel dinainte.
 */
export function groupOrgUnitsByParent(units) {
  const ids = new Set(units.map(u => u.id));
  const byParent = {};
  units.forEach(u => {
    const key = (u.parent_id && ids.has(u.parent_id)) ? u.parent_id : "root";
    (byParent[key] = byParent[key] || []).push(u);
  });
  return byParent;
}
